module.exports = __webpack_public_path__ + "static/media/club-logo.ef50ab8a.svg";